import gql from "graphql-tag";

export const MARK_AS_READ = gql`
  mutation ($input: markAsReadInput) {
    markAsReadMessages(input: $input)
  }
`;
